import { useEscopoMacroSecao } from "./use-escopo-macro-secao";
import { EscopoMacroSecaoView } from "./view-escopo-macro-secao";
import type { EscopoMacroCasca } from "./types-escopo-macro-secao";

export function EscopoMacroSecao(props: EscopoMacroCasca) {
  const vm = useEscopoMacroSecao(props);

  return <EscopoMacroSecaoView {...props} {...vm} />;
}

export type * from "./types-escopo-macro-secao";
